module.exports = __webpack_public_path__ + "static/media/anti-oxidant-icon.37afd159.png";